import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Layout from "src/containers/layout";
import useSidebar from "./hooks/useSidebar";
import ReactGA from "react-ga";

const App = () => {
  useSidebar();

  // Googla Analytics
  useEffect(() => {
    ReactGA.initialize("UA-83618163-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <Layout />
      <ToastContainer theme="light" position="bottom-right" />
    </>
  );
};

export default App;
